import { IStateAutocomplete } from 'addresses/types';

import { IUpsertContactGroupForm } from './types';

export const mapContactGroupForm = (data: IUpsertContactGroupForm) => {
  return {
    contactGroup: {
      ...(data?.id && { id: data.id }),
      name: data.name,
      website: data.website,
      contactGroupingId: data.contactGrouping?.id,
      baseMargin: data.baseMargin,
      baseDiscount: data.baseDiscount,
      // Never `[]` — it serializes to "" in multipart and the BE then iterates over a string.
      // `null` is dropped by postForm, which is how a company with no domains is created.
      domains: data.domains?.length > 0 ? data.domains.map((domain) => domain.id) : null,
      isCustomer: data.isCustomer ? 1 : 0,
      isVendor: data.isVendor ? 1 : 0,
      automatedPricing: data.automatedPricing ? 1 : 0,
      autoLeadTimeEnabled: data.autoLeadTimeEnabled ? 1 : 0,
      showInventory: data.showInventory ? 1 : 0,
      freightEnabled: data.freightEnabled ? 1 : 0,
      companyAddress: {
        name: data.defaultAddress.name,
        line1: data.defaultAddress.line1,
        line2: data.defaultAddress.line2,
        country: data.defaultAddress.country?.abbreviation,
        zip: data.defaultAddress.zip,
        city: data.defaultAddress.city,
        state:
          (data.defaultAddress.state as IStateAutocomplete)?.id?.toString() ||
          (data.defaultAddress.state as string),
      },
    },
  };
};
